import { Crosshair, Flag, Gauge, Trophy } from 'lucide-react';
import Eyebrow from '../ui/Eyebrow';

export default function ManagerMilestones({ milestone }) {
  if (!milestone) return null;
  const cards = [
    { icon: Flag, label: 'Win marker', value: milestone.winTarget, copy: milestone.winCopy },
    { icon: Gauge, label: 'Lifetime PF chase', value: milestone.pointsTarget || '#1', copy: milestone.pointsCopy },
    { icon: Crosshair, label: 'Active playoff streak', value: milestone.playoffStreak, copy: milestone.playoffCopy },
    { icon: Trophy, label: 'Championship pressure', value: milestone.latestTitle || 'First ring', copy: `${milestone.droughtCopy} ${milestone.titleCopy}` },
  ];
  return (
    <section className="px-6 md:px-14 py-14 border-b border-border bg-bg-deep" data-testid="manager-milestones">
      <Eyebrow color="red">2026 ROAD MAP</Eyebrow>
      <h2 className="mt-3 text-display-xs md:text-display-sm font-black tracking-normal leading-none">The records within reach.</h2>
      <div className="mt-7 grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-3">
        {cards.map(({ icon: Icon, label, value, copy }) => (
          <article key={label} className="bg-bg-surface border-t-[3px] border-accent-gold p-5">
            <div className="flex items-center gap-2 text-[9px] tracking-[0.16em] text-accent-gold font-black"><Icon size={14} />{label.toUpperCase()}</div>
            <div className="mt-4 font-display text-4xl font-black text-ink-primary">{value}</div>
            <p className="mt-2 text-[11px] text-ink-secondary leading-relaxed italic">{copy}</p>
          </article>
        ))}
      </div>
    </section>
  );
}
